/**
 * @callback asyncFunction
 * @async
 * @return {Promise<*>}
 */

// array cbs
/**
 * @callback arrayCallback
 * @param {*} item
 * @param {number} index
 * @param {array<*>} array
 * @return {*}
 */

/**
 * @callback arrayCallbackBoolean
 * @param {*} item
 * @param {number} index
 * @param {array<*>} array
 * @return {boolean}
 */

/**
 * @callback arrayReduceCallback
 * @param {*} previousValue
 * @param {*} currentValue
 * @param {number} index
 * @param {array<*>} array
 * @return {*}
 */

// async array cbs
/**
 * @callback asyncArrayCallback
 * @param {*} item
 * @param {number} index
 * @param {array} array
 * @return {Promise<*>}
 */

/**
 * @callback asyncArrayCallbackBoolean
 * @param {*} item
 * @param {number} index
 * @param {array} array
 * @return {Promise<boolean>}
 */

/**
 * @callback asyncArrayReduceCallback
 * @param {*} previousValue
 * @param {*} currentValue
 * @param {number} index
 * @param {array} array
 * @return {Promise<*>}
 */
